/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Your_StatusInputs */



/**
* | output |
* | --- |
* | "Your status:" |
*
* @param {Tournament_Your_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_your_status = /** @type {((inputs?: Tournament_Your_StatusInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Your_StatusInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre statut :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su estado:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seu status:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo stato:")
	return /** @type {LocalizedString} */ ("Your status:")
});